<template>
    <div class="wrapper">
        <xx-select v-model="areaId" :list="list" v-if="!loading" value-key="value" v-bind="$attrs" v-on="$listeners" placeholder="请选择库区"></xx-select>
        <div class="loading" v-else>
            <i class="el-icon-loading"></i>
            加载中
        </div>
    </div>
</template>

<script>
import XxSelect from './index';

export default {
    name: 'XxAreaSelectWws',
    props: {
        value: {
            required: false
        },
        poiId: {
            required: false
        },
        responseFilter: {
            type: Function,
            default: res => {
                return res;
            }
        },
        setDefault: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            areaId: this.value,
            list: [],
            loading: false
        };
    },
    components: {
        XxSelect
    },

    watch: {
        poiId() {
            this.areaId = Array.isArray(this.areaId) ? [] : '';
            this.fetchData();
        },
        areaId: {
            deep: true,
            handler(v, ov) {
                this.$emit('input', v);
            }
        },
        value: {
            deep: true,
            handler(v) {
                this.areaId = v;
            }
        }
    },
    created() {
        if (this.poiId) {
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            this.loading = true;
            return this.$get({
                url: `${location.origin}/api/m/shop/wws/stocktake/getAreaList`,
                params: {
                    poiId: this.poiId
                },
                options: {
                    parseData: false
                }
            }).then(res => {
                this.loading = false;
                let ret = (res.data || []).map(item => {
                    return Object.assign({}, item, {
                        label: item.name,
                        value: item.id
                    });
                });

                this.list = this.responseFilter(ret);
                if (this.setDefault) {
                    this.areaId = this.list[0].value;
                }
            });
        },
        async set(val) {
            await this.$nextTick();
            this.areaId = val;
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper {
    display: inline-block;
}
.loading {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    color: #999;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    line-height: 32px;
    outline: none;
    padding: 0 15px;
    font-size: 12px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 193px;
}
</style>
